export default __webpack_public_path__ + "static/media/episode2Trailer.537b1082.jpg";